import { createActionConst } from '../../../../utils/action.utils';

const USER_GROUPS_NAMESPACE = 'USERS_GROUPS';

export const GET_USER_GROUPS = createActionConst(USER_GROUPS_NAMESPACE, 'GET_USER_GROUPSS');
export const CREATE_USER_GROUP = createActionConst(USER_GROUPS_NAMESPACE, 'CREATE_USER_GROUP');
export const DELETE_USER_GROUP = createActionConst(USER_GROUPS_NAMESPACE, 'DELETE_USER_GROUP');

export const STORE_USER_GROUPS = createActionConst(USER_GROUPS_NAMESPACE, 'STORE_USER_GROUPS');
export const CLEAR_USER_GROUPS = createActionConst(USER_GROUPS_NAMESPACE, 'CLEAR_USER_GROUPS');
export const UPDATE_USER_GROUP = createActionConst(USER_GROUPS_NAMESPACE, 'UPDATE_USER_GROUP');
